import React, { HTMLAttributes, useEffect, useState } from 'react';
import { ReactComponent as PoweredByJoveLogoLight } from '@/website/assets/poweredby-jove-light.svg';
import { ReactComponent as PoweredByJoveLogo } from '@/website/assets/poweredby-jove.svg';
import { promotionInfoStore } from '@/website/store/promotion/promotionInfoStore';
import { Box } from '@mui/material';
import clsx from 'clsx';

type HeaderLogoViewProps = HTMLAttributes<HTMLDivElement> & {
  customLogoUrl?: string;
  hideJoveLogo?: boolean;
};
const HeaderLogoView = (props: HeaderLogoViewProps): React.ReactElement => {
  const { className, customLogoUrl, hideJoveLogo } = props;
  const {
    state: { promotionInfo },
  } = promotionInfoStore();
  const [logoSizeInfo, setLogoSizeInfo] = useState({
    height: '70px',
  });

  /**
   * effects
   */
  useEffect(() => {
    setLogoSizeInfo({
      height: promotionInfo?.payload?.website_configuration?.header_information?.logo_height || '70px',
    });
  }, [promotionInfo]);

  return (
    <div className={clsx('flex', className)}>
      {customLogoUrl && <img src={customLogoUrl} alt="logo" className="w-auto" style={{ height: logoSizeInfo?.height }} />}
      {!hideJoveLogo && (
        <Box className="flex flex-row">
          <PoweredByJoveLogoLight className="block lg:hidden" />
          <PoweredByJoveLogo className="hidden lg:block" />
        </Box>
      )}
    </div>
  );
};

export default HeaderLogoView;
